import { render, staticRenderFns } from "./UpdateLegalUser.vue?vue&type=template&id=31895ad6"
import script from "./UpdateLegalUser.vue?vue&type=script&lang=js"
export * from "./UpdateLegalUser.vue?vue&type=script&lang=js"
import style0 from "./UpdateLegalUser.vue?vue&type=style&index=0&id=31895ad6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports